
import { Vue, Component } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import DashboardCourse from '../../components/Dashboards/DashboardCourse.vue'
  @Component({
    components: { DashboardCourse }
  })
export default class baohe extends Vue {
  mounted() {}
}
